var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudMoon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07178 5.53077C12.475 5.83283 15.233 8.32675 16.0223 11.5847C16.8554 11.6564 17.6252 11.9382 18.2831 12.3757C20.4805 11.3331 22 9.09397 22 6.5C22 6.19925 21.5492 6.14954 21.3937 6.40695C20.6538 7.63141 19.31 8.45 17.775 8.45C15.4416 8.45 13.55 6.5584 13.55 4.225C13.55 2.69 14.3686 1.34619 15.5931 0.606296C15.8505 0.450756 15.8008 0 15.5 0C12.2395 0 9.53975 2.40063 9.07178 5.53077Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09803 18.5857L9.65207 16.0989C9.89717 15.8602 10.3131 16.0886 10.2227 16.4123L9.68439 18.3398L11.7478 18.8702C11.9995 18.935 12.0849 19.2362 11.902 19.4143L9.34793 21.9011C9.10283 22.1398 8.68693 21.9114 8.77731 21.5877L9.31561 19.6602L7.25222 19.1298C7.00047 19.065 6.9151 18.7638 7.09803 18.5857Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.313 20C13.8337 18.9856 13.2509 17.7079 12.1212 17.4175L11.541 17.2683L11.6674 16.8157C11.931 15.8718 11.4121 15.0742 10.7853 14.7299C10.1661 14.3899 9.26481 14.3823 8.60563 15.0241L6.05159 17.511C5.50743 18.0408 5.38934 18.74 5.5793 19.3433C3.45983 18.2871 2 16.0674 2 13.5C2 9.91015 4.85418 7 8.375 7C11.7899 7 14.5777 9.73768 14.7423 13.1779C15.0163 13.1053 15.3037 13.0667 15.6 13.0667C17.4778 13.0667 19 14.6187 19 16.5333C19 18.4479 17.4778 20 15.6 20H13.313Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudMoon1);
export default __webpack_public_path__ + "static/media/cloud-moon-1.977f7f1476d891ae9c8e94c129554798.svg";
export { ForwardRef as ReactComponent };